import { useContext, useMemo } from 'react'

import { photoViewerBasePath } from 'components/page/PhotoViewer/PhotoViewer.paths'
import { profilePath } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useAuthorized } from 'hooks/useAuthorized'
import { useLayoutContext } from 'hooks/useLayoutContext'

import { ProfileNextContext } from '../../ProfileMain/context/ProfileNextContext'

export const usePhotoUrl = (photoId: number) => {
  const authorized = useAuthorized()
  const { baseUrl } = useLayoutContext()
  const { place, incognito, profileId } = useContext(ProfileNextContext)
  const authorizedPath = useAuthorizationPath()

  const profilePhotoViewerBaseUrl = mergeAllUrls(baseUrl, photoViewerBasePath)
  const ratingPhotoViewerBaseUrl = mergeAllUrls(
    baseUrl,
    profilePath,
    profileId!,
    photoViewerBasePath
  )

  return useMemo(() => {
    if (!authorized && incognito) {
      return authorizedPath
    }

    const basePhotoUrl =
      place === 'profile' ? profilePhotoViewerBaseUrl : ratingPhotoViewerBaseUrl

    return mergeAllUrls(basePhotoUrl, photoId)
  }, [
    authorized,
    incognito,
    place,
    profilePhotoViewerBaseUrl,
    ratingPhotoViewerBaseUrl,
    photoId,
    authorizedPath,
  ])
}
